import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar */}
      <Navbar logo="/assets/logo-black.png" darkText={true} />

      {/* Ana içerik */}
      <div
        className="flex-grow w-full bg-cover bg-center relative"
        style={{ backgroundImage: "url('/assets/bg.JPG')" }}
      >
        <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white text-center px-4 py-24">

          {/* Logo */}
          <motion.img
            src="/assets/logo-white.png"
            alt="İskoçsan Kauçuk Logo"
            initial={{ opacity: 0, y: -40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="h-28 md:h-36 mb-8"
          />

          {/* SLOGAN – ALT ALTA / NOKTASIZ */}
          <motion.div
            className="
              font-bebas
              text-xl md:text-3xl
              tracking-[0.18em]
              text-white
              mb-16
              leading-[1.3]
            "
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            {t("home.slogan", { returnObjects: true }).map((word, index) => (
              <div key={index}>{word}</div>
            ))}
          </motion.div>

          {/* Buton */}
          <motion.button
            onClick={() => navigate("/products")}
            className="px-6 py-3 rounded-full bg-blue-600 hover:bg-blue-700 transition text-white font-semibold shadow-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {t("home.button")}
          </motion.button>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
